module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PT-8b025d022865718983d19414f24b205b.png";